<template>
  <div @keydown.enter="downInputSearch">
    <component
      v-if="filterFieldItem.type==='paas-shortText' || filterFieldItem.type==='paas-textArea'"
      v-model="search"
      v-bind="componentsInfo.attrs"
      :is="componentsInfo.tagName"
      @blur="handleBlur"
    />
    <component
      v-else
      v-model.trim="search"
      :field="filterFieldItem"
      v-bind="componentsInfo.attrs"
      :is="componentsInfo.tagName"
    />
  </div>
</template>

<script>
import {componentsInfo} from '../utils/share'
import {assign, merge} from 'lodash-es'
import FilterBoole from '../components/container/filter-item/filter-boole'
import FilterDateBetweenEqual from '../components/container/filter-item/filter-date-between-equal'
import ListSearchInputNumber from '../components/container/filter-item/list-search-input-number'

export default {
  name: 'filter-item-render',
  components: {
    FilterBoole,
    FilterDateBetweenEqual,
    ListSearchInputNumber
  },
  props: {
    filterFieldItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fetchDataHandleEvent: Function,
    conditionList: Object
  },
  data () {
    let {inValueHandle} = this.filterConfig()
    const value = this.conditionList?.[this.filterFieldItem.apiName]?.value || ''
    return {
      search: inValueHandle ? inValueHandle(this.filterFieldItem, value) : value
    }
  },
  computed: {
    // 对组件入参的值处理
    componentsInfo () {
      const config = this.filterConfig()
      if (!this.search && config.defaultValue) {
        this.search = config.defaultValue
      }
      const props = assign({}, this.filterFieldItem?.props)
      props.placeholder = props?.filterPlaceholder || config.attrs.placeholder || props.placeholder
      let _field = {
        ...config,
        attrs: assign({}, props, config.attrs, {placeholder: props.placeholder})
      }
      delete _field.attrs.value
      this.filterFieldItem.placeholder = props.placeholder
      return _field
    }
  },
  watch: {
    search: {
      deep: true,
      handler (value) {
        const {apiName, type, radio} = this.filterFieldItem
        const dataType = Object.prototype.toString.call(value)
        const typeMap = {
          '[object String]': (cbData) => cbData.replace(/\s*/g, '') === '',
          '[object Array]': (cbData) => cbData.filter(v => v).length === 0,
          '[object Object]': (cbData) => Object.keys(cbData).length === 0
        }
        let {symbol, outValueHandle} = this.filterConfig()

        // 处理清空后的数据
        if (typeMap[dataType] && typeMap[dataType](value)) {
          return this.$emit('input-change', {apiName, symbol, value})
        }

        // 行政区的判断
        if (type === 'paas-region') {
          const filter = (
            {townCode, countyCode, cityCode, provinceCode}
          ) => (townCode || countyCode || cityCode || provinceCode)
          if (radio) {
            value = filter(value)
          } else {
            value = value.map(v => filter(v))
          }
        }
        this.$emit('input-change', {
          apiName,
          symbol,
          value: outValueHandle ? outValueHandle(this.filterFieldItem, value) : value
        })
      }
    }
  },
  methods: {
    handleBlur (e) {
      e.target.value = e.target.value.replace(/^\s+|\s+$/g, '')
      const {apiName} = this.filterFieldItem
      this.search = e.target.value.replace(/^\s+|\s+$/g, '')
      this.$emit('input-trim', {search: this.search, apiName})
    },
    filterConfig () {
      const {type, filterCondition} = this.filterFieldItem
      let config = componentsInfo[type]
        ? componentsInfo[type][filterCondition] || componentsInfo[type]['default']
        : componentsInfo['default']
      if (typeof config === 'function') {
        config = config(this.filterFieldItem)
      }
      return merge({
        attrs: {
          disabled: false,
          isPureText: false
        }
      }, config, this.filterFieldItem)
    },
    downInputSearch () {
      if (this.componentsInfo.tagName === 'el-input') {
        this.$emit('fetch-data-handle-event', true)
      }
    }
  }
}
</script>
